import { Select } from "antd";
import image from "../../../images/FilterOutlined gray.png";
import { useTranslation } from "react-i18next";
interface button {
  value: any;
  onChange: any;
  // key: any;
}

export const FilterInput = ({ value, onChange }: button) => {

  const { t } = useTranslation("common");

  return (
    <>
      <Select
        value={value}
        placeholder={t("status")}
        style={{ width: "6rem" }}
        // key={key}
        size="large"
        onChange={onChange}
        suffixIcon={<img src={image} alt="" />}
        options={[
          {
            value: true,
            label: t("active"),
          },
          {
            value: false,
            label: t("inactive"),
          },
        ]}
      />
    </>
  );
};
